import styled from 'styled-components';
import SkipButton from 'js/components/core/SteppedPage/SkipButton';

export default styled(SkipButton)`
  border: none;
  color: #666;

  &:hover {
    color: black;
  }

  &:active {
    box-shadow: none;
  }
`;
